import React, { useEffect, useState } from 'react';
import 'antd/dist/antd.css';
import { fetchApi } from "../../../services/api";
const TestResultJsonInfo = () => {
	const [jsondata, setJsondata] = useState();
	useEffect(() => {
		var token = sessionStorage.getItem("scoreCardId");
		fetchJdondata(token);
	}, []);
	const fetchJdondata =(token)=>{
		let payload = { score_card_id: token };
		fetchApi(`/scorecard-details`, "post", payload).then((res) => {
			if (res && res.data) {
				setJsondata(JSON.stringify(res.data));
			}else{
				setJsondata([]);
			}
		});
	};
	return (
		<>
			<p>{jsondata}</p>
		</>
	);
};
export default TestResultJsonInfo;
